module.exports = __webpack_public_path__ + "static/rcc-os-fa-graph-desktop-17214fdaf61bf773e4a5b268f25f453a.png";